import {$authHost, $host} from "./index";
import {CATEGORIES} from "./ApiEndpoints";

export const fetchCategories = async () => {
    const {data} = await $host.get(CATEGORIES);
    return data;
}

/**
 * @param {string} title
 * @param {number|null} [displayOrder] Опционально. null/undefined → бэк поставит в конец.
 */
export const createCategory = async (title, displayOrder = null) => {
    const payload = {title};
    if (displayOrder !== null && displayOrder !== undefined && displayOrder !== '') {
        payload.displayOrder = Number(displayOrder);
    }
    const {data} = await $authHost.post('/v1/admin/categories', payload);
    return data;
}

/**
 * @param {number|string} id
 * @param {string|null} title null/undefined → название не менять
 * @param {number|null} [displayOrder] null/undefined → порядок не менять
 */
export const updateCategory = async (id, title, displayOrder = null) => {
    const payload = {};
    if (title !== null && title !== undefined) {
        payload.title = title;
    }
    if (displayOrder !== null && displayOrder !== undefined && displayOrder !== '') {
        payload.displayOrder = Number(displayOrder);
    }
    const {data} = await $authHost.put(`/v1/admin/categories/${id}`, payload);
    return data;
}

export const deleteCategory = async (id) => {
    const {data} = await $authHost.delete(`/v1/admin/categories/${id}`);
    return data;
}
